import Cookies from 'js-cookie';

export const getUserInfo = () => {
  const userData = Cookies.get('userDataProofreader');
  return userData ? JSON.parse(userData)?.UserInfo : null;
};
